var map = {
	"./admin_logs": 6621,
	"./admin_logs.json": 6621,
	"./app_admin_logs": 1795,
	"./app_admin_logs.json": 1795,
	"./app_api_logs": 4662,
	"./app_api_logs.json": 4662,
	"./app_commits_logs": 7342,
	"./app_commits_logs.json": 7342,
	"./app_job_logs": 3175,
	"./app_job_logs.json": 3175,
	"./app_provider_logs": 7909,
	"./app_provider_logs.json": 7909,
	"./app_website_logs": 3894,
	"./app_website_logs.json": 3894,
	"./category": 880,
	"./category.json": 880,
	"./checkout": 5076,
	"./checkout.json": 5076,
	"./comment": 7618,
	"./comment.json": 7618,
	"./content": 5275,
	"./content.json": 5275,
	"./dentity_role": 9417,
	"./dentity_role.json": 9417,
	"./discount_code": 9691,
	"./discount_code.json": 9691,
	"./discount_quantity": 3120,
	"./discount_quantity.json": 3120,
	"./discount_quantity_range": 5572,
	"./discount_quantity_range.json": 5572,
	"./enumeration_location": 7829,
	"./enumeration_location.json": 7829,
	"./file_identity": 1946,
	"./file_identity.json": 1946,
	"./form": 8012,
	"./form.json": 8012,
	"./form_element": 6717,
	"./form_element.json": 6717,
	"./form_enumeration": 618,
	"./form_enumeration.json": 618,
	"./form_validation": 7228,
	"./form_validation copy": 5826,
	"./form_validation copy.json": 5826,
	"./form_validation.json": 7228,
	"./identity_admin": 3726,
	"./identity_admin.json": 3726,
	"./identity_provider": 7328,
	"./identity_provider.json": 7328,
	"./identity_user": 3163,
	"./identity_user.json": 3163,
	"./income_type": 799,
	"./income_type.json": 799,
	"./internet_receipt": 7378,
	"./internet_receipt.json": 7378,
	"./notifications": 5022,
	"./notifications.json": 5022,
	"./order": 5805,
	"./order.json": 5805,
	"./page": 5189,
	"./page.json": 5189,
	"./page_control": 8733,
	"./page_control.json": 8733,
	"./page_function": 1994,
	"./page_function.json": 1994,
	"./page_static": 5389,
	"./page_static copy": 3053,
	"./page_static copy.json": 3053,
	"./page_static.json": 5389,
	"./page_template": 5625,
	"./page_template.json": 5625,
	"./payline": 1686,
	"./payline.json": 1686,
	"./permission_admin": 9827,
	"./permission_admin.json": 9827,
	"./permission_provider": 9406,
	"./permission_provider.json": 9406,
	"./permission_user": 6842,
	"./permission_user.json": 6842,
	"./price": 6331,
	"./price.json": 6331,
	"./product": 477,
	"./product.json": 477,
	"./profile": 2875,
	"./profile.json": 2875,
	"./provider_logs": 9561,
	"./provider_logs.json": 9561,
	"./provider_ticket": 7953,
	"./provider_ticket.json": 7953,
	"./providersMessage": 9802,
	"./providersMessage.json": 9802,
	"./remittance": 4971,
	"./remittance.json": 4971,
	"./routes-list/apps": 3078,
	"./routes-list/apps.json": 3078,
	"./routes-list/currency": 9317,
	"./routes-list/currency-request": 2054,
	"./routes-list/currency-request.json": 2054,
	"./routes-list/currency.json": 9317,
	"./routes-list/location_service": 2712,
	"./routes-list/location_service.json": 2712,
	"./routes-list/notification": 1154,
	"./routes-list/notification.json": 1154,
	"./routes-list/payline": 7853,
	"./routes-list/payline.json": 7853,
	"./routes-list/recaptcha": 5385,
	"./routes-list/recaptcha.json": 5385,
	"./routes-list/regex_password": 6619,
	"./routes-list/regex_password.json": 6619,
	"./routes-list/remittance": 462,
	"./routes-list/remittance.json": 462,
	"./routes-list/server_settings": 7605,
	"./routes-list/server_settings.json": 7605,
	"./routes-list/sms": 4152,
	"./routes-list/sms.json": 4152,
	"./routes-list/sms_expire": 9583,
	"./routes-list/sms_expire.json": 9583,
	"./routes-list/template": 3179,
	"./routes-list/template.json": 3179,
	"./routes-list/token": 3207,
	"./routes-list/token.json": 3207,
	"./routes-list/upload_max_size": 9778,
	"./routes-list/upload_max_size.json": 9778,
	"./routes-list/user_authorize": 543,
	"./routes-list/user_authorize.json": 543,
	"./routes-list/word-template": 6156,
	"./routes-list/word-template.json": 6156,
	"./score": 859,
	"./score.json": 859,
	"./sellers": 2743,
	"./sellers.json": 2743,
	"./send_notifications": 2522,
	"./send_notifications.json": 2522,
	"./send_sms": 6544,
	"./send_sms.json": 6544,
	"./shop_setting": 4293,
	"./shop_setting.json": 4293,
	"./shop_setting_currency_type": 6957,
	"./shop_setting_currency_type.json": 6957,
	"./shop_setting_factor_layer": 271,
	"./shop_setting_factor_layer.json": 271,
	"./shop_setting_payment_type": 4615,
	"./shop_setting_payment_type.json": 4615,
	"./shop_setting_transport_type": 454,
	"./shop_setting_transport_type.json": 454,
	"./shop_setting_wage_type": 6600,
	"./shop_setting_wage_type.json": 6600,
	"./shop_setting_withdraw_type": 9771,
	"./shop_setting_withdraw_type.json": 9771,
	"./subscription_type": 6884,
	"./subscription_type.json": 6884,
	"./subscriptions": 1973,
	"./subscriptions.json": 1973,
	"./tag": 6218,
	"./tag.json": 6218,
	"./tokens_admin": 7671,
	"./tokens_admin.json": 7671,
	"./tokens_provider": 4923,
	"./tokens_provider.json": 4923,
	"./tokens_user": 2271,
	"./tokens_user.json": 2271,
	"./transactions": 1916,
	"./transactions.json": 1916,
	"./user_logs": 1253,
	"./user_logs.json": 1253,
	"./user_ticket": 1630,
	"./user_ticket.json": 1630,
	"./usersMessage": 805,
	"./usersMessage.json": 805,
	"./wallet": 1098,
	"./wallet.json": 1098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6616;